import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {useGetJobDetailsQuery} from '../api/employer';
import Button from '../components/ui/Button';
import {
  expEnum,
  expLvl,
  jobShiftJson,
  salaryPeriodEnum,
  workPrefEnum,
} from '../utils/constants';

const JobDetails = () => {
  const {jobId} = useParams();
  const navigate = useNavigate();

  const {
    data: jobDetails,
    isLoading: isJobDetailsLoading,
    error,
  } = useGetJobDetailsQuery(jobId);

  if (isJobDetailsLoading) {
    return <>Loading...</>;
  }

  if (error) {
    return <>Something went wrong</>;
  }

  const {
    title,
    city,
    state,
    description,
    companyInfo,
    requirements,
    responsiblities,
    jobType,
    jobShift,
    requiredExp,
    salary,
    salaryPeriod,
    vacancies,
    expLevel,
    qualifications,
    technicalSkills,
    interpersonalSkills,
  } = jobDetails.data;

  const technicalSkillsList = technicalSkills.map(({name}) => name).join(', ');

  const interpersonalSkillsList = interpersonalSkills
    .map(({name}) => name)
    .join(', ');

  return (
    <div className="p-6">
      <div className="px-10 py-6 w-full max-w-[1000px] bg-white mx-auto">
        <div className="text-2xl font-bold">{title}</div>
        <div className="text-[16px]">
          {[city, state].filter(Boolean).join(', ')}
        </div>
        <hr className="my-[15px]" />
        <div className="text-xl font-bold">Description</div>
        <div
          className="text-[16px]"
          dangerouslySetInnerHTML={{__html: description || '-'}}
        />
        <hr className="my-[15px]" />
        <div className="text-xl font-bold">Pitch (Company Info)</div>
        <div className="text-[16px]">{companyInfo}</div>
        <hr className="my-[15px]" />
        <div className="text-xl font-bold">Requirements</div>
        <div
          className="text-[16px]"
          dangerouslySetInnerHTML={{__html: requirements || '-'}}
        />
        <hr className="my-[15px]" />
        <div className="text-xl font-bold">Responsibilities</div>
        <div
          className="text-[16px]"
          dangerouslySetInnerHTML={{
            __html: responsiblities || '-',
          }}
        />
        <hr className="my-[15px]" />
        <div className="grid grid-cols-3 space-y-2 space-y-reverse">
          <div className="flex text-[16px] font-bold">
            Job Type:
            <div className="ml-2 font-normal">{workPrefEnum[jobType]}</div>
          </div>
          <div className="flex border-l-2 border-gray-800 pl-4 text-[16px] font-bold">
            Job Shift:
            <div className="ml-2 font-normal">{jobShiftJson[jobShift]}</div>
          </div>
          <div className="flex border-l-2 border-gray-800 pl-4 text-[16px] font-bold">
            Required experience:
            <div className="ml-2 font-normal">{expEnum[requiredExp]}</div>
          </div>
          <div className="flex text-[16px] font-bold">
            Salary:
            <div className="ml-2 font-normal">
              {salary}
              {salaryPeriodEnum[salaryPeriod]}
            </div>
          </div>
          <div className="flex border-l-2 border-gray-800 pl-4 text-[16px] font-bold">
            Vacancies:
            <div className="ml-2 font-normal">{vacancies}</div>
          </div>
          <div className="flex border-l-2 border-gray-800 pl-4 text-[16px] font-bold">
            Experience level:
            <div className="ml-2 font-normal">{expLvl[expLevel]}</div>
          </div>
        </div>
        <hr className="my-[15px]" />
        <div className="flex text-[16px] font-bold">
          Required qualification:
          <div className="ml-2 font-normal">{qualifications}</div>
        </div>
        {technicalSkillsList && (
          <>
            <hr className="my-[15px]" />
            <div className="flex text-[16px] font-bold">
              Technical skills:
              <div className="ml-2 font-normal">{technicalSkillsList}</div>
            </div>
          </>
        )}
        {interpersonalSkillsList && (
          <>
            <hr className="my-[15px]" />
            <div className="flex text-[16px] font-bold">
              Interpersonal skills:
              <div className="ml-2 font-normal">{interpersonalSkillsList}</div>
            </div>
          </>
        )}
      </div>

      <div className="pt-6 text-center">
        <Button className="w-[300px]" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>
    </div>
  );
};

export default JobDetails;
